import "./App.css";
import { Route, Routes } from "react-router-dom";
import { UserLogin } from "./components/user/UserLogin";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Dashboard from "./components//dashboard/Dashboard";
import ChangeLogs from "./components/pages/ChangeLogs";
import UserDetails from "./components/pages/UserDetails";
import PageNotFound from "./components/pages/pageNotFound";
import JSON from "./components/pages/JSON"

import React, { useState, useEffect } from 'react'
// import ProtectedRoutes from "./ProtectedRoutes";
import Protected from "./Protected";


function App() {
  const [isSignedIn, setIsSignedIn] = useState(sessionStorage.getItem('isSignedIn') === 'true')


  const signin = () => {
    setIsSignedIn(true)
    sessionStorage.setItem('isSignedIn', 'true')
  }

  const signout = () => {
    setIsSignedIn(false)
    sessionStorage.setItem('isSignedIn', 'false')
  }

  useEffect(() => {
    if (sessionStorage.getItem('isSignedIn') === null) {
      sessionStorage.setItem('isSignedIn', 'false')
    }
  }, [])

  return (
    <div>
      <ToastContainer
        position="top-center"
        autoClose={3000}
        hideProgressBar
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
      />

      <Routes>
        <Route path="/" element={<UserLogin signin={signin} />} />
        <Route path="/login" element={<UserLogin signin={signin} />} />
        <Route path="/*" element={<PageNotFound />} />

        <Route path="/dashboard"
          element={
            <Protected isSignedIn={isSignedIn} >
              <Dashboard signin={signin} signout={signout} />
            </Protected>
          } />
        <Route path="/makeJSON"
          element={
            <Protected isSignedIn={isSignedIn} >
              <JSON signin={signin} signout={signout} />
            </Protected>
          } />
        <Route path="/logs"
          element={
            <Protected isSignedIn={isSignedIn}>
              <ChangeLogs signin={signin} signout={signout} />
            </Protected>
          } />
        <Route path="/users"
          element={
            <Protected isSignedIn={isSignedIn} >
              <UserDetails signin={signin} signout={signout} />
            </Protected>
          } />
        <Route path="/logout"
          element={
            <Protected isSignedIn={isSignedIn}>
              <UserLogin />
            </Protected>
          } />
        {/* <Route path="/logs" element={<ProjectDetails />} />
        <Route path="/users" element={<ModuleDetails />} />
        <Route path="/logout" element={<UserLogin />} /> */}
      </Routes>
    </div>
  );
}

export default App;
